module.exports = __webpack_public_path__ + "static/services-3-66d01a226566aa46013345c9bef3bfaa.jpg";